import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ element, allowedRoles }) => {
  const { currentUser, userData, loading } = useAuth();

  if (loading) return <p className="centered-text">Cargando...</p>;

  if (!currentUser) return <Navigate to="/admin/login" />;

  if (allowedRoles.includes(userData?.role)) {
    return element;
  }

  return <Navigate to="/" />;
};

export default ProtectedRoute;

